<template>
    <div>
        <base-input
            input-group-classes="input-group-merge"
            v-model="model.title"
            :label="$t('topic.topic_title')"
            v-validate="'required'"
            :name="$t('topic.title')"
            :error="errors.first($t('topic.title'))" />
        <Editor
            class="nch--html-editor"
            v-model="model.comment"
            v-validate="'required'"
            :name="$t('topic.question')" />
        <BaseButton
            type="success"
            :disabled="disableBtn"
            @click="postTopic">{{$t('topic.post')}}</BaseButton>
    </div>
</template>

<script>
import BaseInput from '../../argon/components/Inputs/BaseInput'
import BaseButton from '../../argon/components/BaseButton'
import Editor from '../../argon/components/Inputs/HtmlEditor'
export default {
    name: 'ForumCreateTopic',
    components: {
        Editor,
        BaseInput,
        BaseButton,
    },
    props: {
        color: {
            type: Object,
            required: true
        },
        id: {
            type: Number
        },
        moderated: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            model: {
                comment: '',
                title: ''
            }
        }
    },
    computed: {
        disableBtn() {
            if (!this.model.title || !this.model.comment) return true
        }
    },
    methods: {
        postTopic() {
            this.$loading.show()
            return window.axios.post(`/api/app/forum/${this.id}/topics`, {
                    title: this.model.title,
                    comment: this.model.comment,
                })
                .then(res => {
                    if(this.moderated) {
                        return this.$notify({
                            type: 'warning',
                            message: this.$t('topic.new_moderated')
                        });
                    }
                    this.$notify({
                        type: 'success',
                        message: res.data.message
                    });
                })
                .catch(err => {
                    console.error(err)
                    this.$notify({
                        type: 'danger',
                        message: err.response.data.error
                    })
                })
                .finally(() => {
                    this.$loading.close()
                    this.model = {
                        comment: '',
                        title: '',
                    }
                
                    this.$emit('postCreated')
                })
        },
    },
}
</script>

<style>

</style>
